(() => {
  const page = document.querySelector('[data-search-page]');
  if (!page) return;
  const input = page.querySelector('[data-search-input]');
  const suggestions = page.querySelector('[data-search-suggestions]');
  const requestedScope = new URLSearchParams(window.location.search).get('view');
  const scope = ['all', 'products', 'info'].includes(requestedScope) ? requestedScope : 'all';
  page.dataset.searchScope = scope;
  const readHandles = (selector) => {
    try { return new Set(JSON.parse(page.querySelector(selector)?.textContent || '[]')); }
    catch (_) { return new Set(); }
  };
  const fudgeHandles = readHandles('[data-fudge-handles]');
  const giftHandles = readHandles('[data-gift-handles]');
  let timer;
  let controller;

  const typeInput = page.querySelector('[data-search-type]');
  const viewInput = page.querySelector('[data-search-view]');
  if (scope !== 'all' && viewInput) {
    viewInput.name = 'view';
    viewInput.value = scope;
  }
  if (typeInput) typeInput.value = scope === 'info' ? 'page,article' : (scope === 'all' ? 'product,page,article' : 'product');
  page.querySelectorAll('.search-scopes a').forEach((link) => {
    const linkScope = new URL(link.href).searchParams.get('view') || 'all';
    const active = linkScope === scope;
    link.classList.toggle('is-active', active);
    if (active) link.setAttribute('aria-current', 'page');
    else link.removeAttribute('aria-current');
  });

  const filterRenderedResults = () => {
    const results = [...page.querySelectorAll('[data-search-result]')];
    if (!results.length) return;
    let visible = 0;
    results.forEach((result) => {
      const kind = result.dataset.resultKind;
      const handle = result.dataset.productHandle || '';
      const show = scope === 'all'
        || (scope === 'info' && kind === 'page')
        || (scope === 'products' && kind === 'product');
      result.hidden = !show;
      if (show) visible += 1;
    });
    const count = page.querySelector('[data-search-results-count]');
    if (count) {
      const terms = count.dataset.searchTerms || '';
      count.textContent = `${visible} ${visible === 1 ? 'result' : 'results'} for “${terms}”`;
    }
    const grid = page.querySelector('.search-results');
    let empty = page.querySelector('[data-filtered-empty]');
    if (visible === 0) {
      if (grid) grid.hidden = true;
      if (!empty) {
        empty = document.createElement('div');
        empty.className = 'search-empty';
        empty.dataset.filteredEmpty = '';
        empty.innerHTML = '<h2>We couldn\u2019t find a match.</h2><p>Try a broader phrase, choose another category, or use one of the popular links above.</p>';
        page.querySelector('[data-search-results-header]')?.after(empty);
      }
    } else {
      if (grid) grid.hidden = false;
      empty?.remove();
    }
  };
  filterRenderedResults();

  const handleFromUrl = (url = '') => url.split('/products/')[1]?.split(/[?#]/)[0] || '';
  const allowedProduct = (product) => {
    const handle = handleFromUrl(product.url);
    return scope !== 'info';
  };
  const escapeHtml = (value = '') => String(value).replace(/[&<>'"]/g, (character) => ({
    '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;'
  }[character]));
  const render = (items) => {
    suggestions.innerHTML = items.map((item) => {
      const image = item.image
        ? `<img src="${escapeHtml(item.image)}" alt="" width="56" height="56">`
        : '<span class="search-suggestion__placeholder" aria-hidden="true"></span>';
      return `<a class="search-suggestion" role="option" href="${escapeHtml(item.url)}">${image}<span><strong>${escapeHtml(item.title)}</strong><small>${escapeHtml(item.kind)}</small></span>${item.price ? `<small>${escapeHtml(item.price)}</small>` : ''}</a>`;
    }).join('');
    suggestions.hidden = items.length === 0;
  };
  const load = async () => {
    const query = input.value.trim();
    if (query.length < 2) { suggestions.hidden = true; return; }
    controller?.abort();
    controller = new AbortController();
    const params = new URLSearchParams({ q: query, 'resources[type]': 'product,page,article', 'resources[limit]': '8' });
    try {
      const response = await fetch(`${window.Shopify.routes.root}search/suggest.json?${params}`, { signal: controller.signal });
      const data = await response.json();
      const results = data.resources?.results || {};
      const products = (results.products || []).filter(allowedProduct).map((product) => ({
        title: product.title, url: product.url, image: product.image, price: product.price, kind: 'Product'
      }));
      const pages = scope === 'products' ? [] : (results.pages || []).map((item) => ({
        title: item.title, url: item.url, image: '', price: '', kind: 'Helpful information'
      }));
      const articles = scope === 'products' ? [] : (results.articles || []).map((item) => ({
        title: item.title, url: item.url, image: '', price: '', kind: 'Helpful information'
      }));
      render((scope === 'info' ? [...pages, ...articles] : [...products, ...pages, ...articles]).slice(0, 6));
    } catch (error) {
      if (error.name !== 'AbortError') suggestions.hidden = true;
    }
  };
  input.addEventListener('input', () => {
    window.clearTimeout(timer);
    timer = window.setTimeout(load, 180);
  });
  input.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') suggestions.hidden = true;
  });
  document.addEventListener('click', (event) => {
    if (!page.contains(event.target)) suggestions.hidden = true;
  });
})();
